var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6", sm: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "lg",
                    "label-class": "addgrouplabel",
                    label: "Group Name",
                    "label-for": "groupName",
                    horizontal: false
                  }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:255|uniqueGroupName",
                        expression: "'required|max:255|uniqueGroupName'"
                      }
                    ],
                    attrs: {
                      "data-vv-name": "group.groupName",
                      "data-vv-as": "Group Name",
                      size: "lg",
                      id: "groupName"
                    },
                    on: { blur: _vm.validateGroupName },
                    model: {
                      value: _vm.group.groupName,
                      callback: function($$v) {
                        _vm.$set(_vm.group, "groupName", $$v)
                      },
                      expression: "group.groupName"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has(
                            "group.groupName"
                          ),
                          expression:
                            "inputValidationErrors.has('group.groupName')"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.inputValidationErrors.first("group.groupName")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.groupNameError,
                          expression: "groupNameError"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        " Group Name already exist. Please enter different name! "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "lg",
                    "label-class": "addgrouplabel",
                    label: "Is Owning Group",
                    "label-for": "isOwningGroup",
                    horizontal: false
                  }
                },
                [
                  _c("b-form-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      size: "lg",
                      "data-vv-name": "group.isOwningGroup",
                      "data-vv-as": "Is Owning Group",
                      options: _vm.isOwningGroupOptions,
                      id: "isOwningGroup"
                    },
                    model: {
                      value: _vm.group.isOwningGroup,
                      callback: function($$v) {
                        _vm.$set(_vm.group, "isOwningGroup", $$v)
                      },
                      expression: "group.isOwningGroup"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has(
                            "group.isOwningGroup"
                          ),
                          expression:
                            "inputValidationErrors.has('group.isOwningGroup')"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.inputValidationErrors.first("group.isOwningGroup")
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "lg",
                    "label-class": "addgrouplabel",
                    label: "State",
                    "label-for": "defaultOrg",
                    horizontal: false
                  }
                },
                [
                  _c("b-form-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: { size: "lg", options: _vm.stateAndAbbrev },
                    model: {
                      value: _vm.stateName,
                      callback: function($$v) {
                        _vm.stateName = $$v
                      },
                      expression: "stateName"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has("stateName"),
                          expression: "inputValidationErrors.has('stateName')"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.inputValidationErrors.first("stateName"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "lg",
                    "label-class": "addgrouplabel",
                    label: "Default Organization",
                    "label-for": "defaultOrg",
                    horizontal: false
                  }
                },
                [
                  _c("b-form-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      size: "lg",
                      options: _vm.defaultOrganizationOptions(_vm.organizations)
                    },
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.group.defaultOrg,
                      callback: function($$v) {
                        _vm.$set(_vm.group, "defaultOrg", $$v)
                      },
                      expression: "group.defaultOrg"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has(
                            "group.defaultOrg"
                          ),
                          expression:
                            "inputValidationErrors.has('group.defaultOrg')"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.inputValidationErrors.first("group.defaultOrg")
                        )
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a882c2b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a882c2b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/GroupForm.vue
// module id = 1921
// module chunks = 0